/** 用户主动取消钱包连接/签名（Uniswap 式：不弹错误 toast） */

function extractMessage(raw) {
  if (raw == null) return ''
  if (typeof raw === 'string') return raw
  if (typeof raw === 'object') {
    const parts = [raw.message, raw.reason, raw.shortMessage, raw.details, raw.data?.message]
    for (const p of parts) {
      if (typeof p === 'string' && p.trim()) return p
    }
  }
  try {
    return String(raw)
  } catch {
    return ''
  }
}

export function isWalletUserCancel(error) {
  const e = error && typeof error === 'object' ? error : {}
  const code = e.code ?? e.error?.code
  if (code === 4001 || code === '4001' || code === 'ACTION_REJECTED') return true

  const text = extractMessage(error).toLowerCase()
  if (!text.trim()) return false

  return (
    /user denied|user rejected|rejected the request|rejected transaction|rejected signature|action_rejected|request rejected/.test(
      text,
    ) ||
    /cancelled|canceled|cancelled by user|canceled by user|user cancel|user closed|closed by user/.test(
      text,
    ) ||
    /connection request reset|request reset|pairing cancelled|pairing canceled|proposal expired|expired pairing|wc_superseded/.test(
      text,
    ) ||
    /modal closed|closed modal|session deleted/.test(text)
  )
}
